@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";
@use "ui/styles/zindex";

.wrapper {
  :global {
    .dropdownMenu {
      position: absolute;
      background-color: var(--background-color);
      border-radius: 4px;
      z-index: zindex.$dropdown;
      overflow: visible;
      padding: 12px 0;
      box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.12);
      border: 1px solid var(--border-color, colorsOld.$stoneLightX1);

      :global {
        .disabled {
          cursor: default;
          color: colorsOld.$stoneLight;
        }
      }

      svg {
        margin-right: 9px;
      }

      hr {
        margin-top: 12px;
        margin-bottom: 12px;
        border-top: 1px solid var(--border-color, colorsOld.$stoneLightX1);
        border-bottom: none;
      }

      > div,
      > a {
        display: flex;
        align-items: center;
        text-decoration: none;
        white-space: nowrap;
        padding: 9px 18px;
        padding-right: 30px;
        font-size: 12px;
        text-align: left;
        cursor: pointer;
        color: var(--text-color);
        background-color: var(--background-color);
        transition: background-color 0.2s;

        &:hover {
          background-color: var(--secondary-background-color);
        }
      }

      :global {
        .dropdown-menu-header {
          display: block;
          font-size: 12px;
          font-weight: fontsOld.$book-weight;
          color: var(--text-color);
          padding: 6px 18px 12px;
          border-bottom: 1px solid var(--border-color, colorsOld.$stoneLightX1);
          margin-bottom: 12px;

          > div {
            margin-bottom: 4px;
          }

          &:hover {
            background-color: inherit;
            cursor: default;
          }

          .dropdown-menu-header-title {
            color: var(--text-color);
            font-size: 14px;
          }

          .dropdown-menu-header-subtitle {
            color: var(--secondary-text-color);
            display: flex;
            align-items: center;

            svg {
              margin-top: 3px;
            }

            .admin_icon {
              &:hover {
                color: colorsOld.$goldDark;
              }
            }

            .sales_manager_icon {
              &:hover {
                color: colorsOld.$sapphire;
              }
            }

            .field_staff_icon {
              &:hover {
                color: colorsOld.$citrine;
              }
            }

            .sales_agent_icon {
              &:hover {
                color: colorsOld.$emeraldDark;
              }
            }

            .drafter_icon {
              &:hover {
                color: colorsOld.$emeraldDark;
              }
            }
          }
        }
      }
    }
  }
}

.right {
  right: 0px;
}

.left {
  left: 0px;
}

.topAligned {
  top: calc(100% + 6px);
}

.bottomAligned {
  bottom: calc(100% + 6px);
}

// Used for SimpleDropDown, eventually can merge
.dropdownMenuWrapper {
  position: relative;
}

.dropdownMenuButton {
  border: none;
  background: none;
  position: relative;
  text-align: right;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed !important;

    &:hover {
      background-color: var(--background-color);
    }
  }

  :global {
    .dropdown-button-circle {
      &:hover {
        background-color: var(--secondary-background-color);
      }
    }
  }
}

.dropdownMenuButtonActive {
  :global {
    .dropdown-button-circle {
      background-color: var(--secondary-background-color);
    }
  }

  &.dropdownMenuButtonBlueHover {
    :global {
      .dropdown-button-circle {
        background-color: colorsOld.$sapphireLightX4;
      }
    }
  }
}

.dropdownMenuButtonBlueHover {
  :global {
    .dropdown-button-circle:hover {
      background-color: colorsOld.$sapphireLightX4;
    }
  }
}

.dropDownMenuButtonOnGreyBgHover {
  :global {
    .dropdown-button-circle:hover {
      background-color: colorsOld.$stoneLightX3;
    }
  }
}

.iconDropDownWrapper {
  position: relative;
  display: flex;
  align-items: center;
  cursor: pointer;

  &.disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  .iconDropDown {
    align-self: flex-end;
  }
}